var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"50px"}},[_c('TableComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }